module.exports = __webpack_public_path__ + "shared/static_img/signout.3791b860.svg";